module.exports = __webpack_public_path__ + "static/media/fa-light-300.b076f7cc.woff2";